// ---------------------------------------------------------------------------
// Páginas de serviço.
//
// Cada item vira um card na home e uma página própria em /<slug>.
// Os slugs são NACIONAIS (sem cidade): a atuação é em todo o país e a URL não
// pode sugerir o contrário. O recorte local aparece no campo `brasilia`, com
// conteúdo específico do DF, e no hub /advogado-criminalista-brasilia.
//
// `cluster` agrupa temas; `pai` aponta para o pilar do cluster. Isso comanda
// os links internos — nada de "outras áreas" aleatórias.
//
// `icone` deve corresponder a uma chave existente em src/components/Icons.js
// ---------------------------------------------------------------------------

const servicos = [
  /* ===================== CLUSTER: PRISÃO ===================== */
  {
    id: 'flagrante',
    slug: 'prisao-em-flagrante',
    cluster: 'prisao',
    pilar: true,
    icone: 'urgencia',
    titulo: 'Prisão em Flagrante',
    h1: 'Advogado para Prisão em Flagrante',
    seo: {
      titulo: 'Advogado para Prisão em Flagrante | Plantão 24 Horas',
      descricao:
        'Alguém foi preso em flagrante? Atuação imediata em delegacia e audiência de custódia, com pedido de liberdade provisória. Atendimento em todo o Brasil.',
    },
    resumo:
      'Atuação nas primeiras horas — o momento em que mais se decide e menos se pensa.',
    itens: [
      'Acompanhamento na delegacia',
      'Auto de prisão em flagrante',
      'Liberdade provisória',
      'Relaxamento de prisão ilegal',
    ],
    intro: [
      'A prisão em flagrante é o momento em que mais se decide e menos se pensa. Em até 24 horas o preso precisa ser apresentado a um juiz, e nessa audiência define-se se ele responderá ao processo solto ou preso — decisão que costuma se arrastar por todo o resto do caso.',
      'O que é dito na delegacia, sem advogado, vira peça dos autos. Por isso o primeiro telefonema deve ser para um defensor, antes de qualquer depoimento.',
    ],
    quandoProcurar: [
      'Um familiar acabou de ser preso e está em delegacia',
      'Você foi conduzido para prestar esclarecimentos e teme ser autuado',
      'A audiência de custódia está marcada para as próximas horas',
      'A prisão em flagrante foi convertida em preventiva',
      'Houve excesso, agressão ou irregularidade na abordagem policial',
    ],
    comoAtuamos: [
      'Localização do preso e contato imediato com a autoridade policial',
      'Acompanhamento do interrogatório, com orientação sobre o direito ao silêncio',
      'Verificação da legalidade do auto de prisão em flagrante',
      'Atuação na audiência de custódia, com pedido de liberdade provisória',
      'Requerimento de relaxamento quando a prisão é ilegal',
      'Proposta de medidas cautelares alternativas à prisão (art. 319 do CPP)',
      'Habeas corpus quando a preventiva é decretada sem fundamento concreto',
    ],
    brasilia:
      'No Distrito Federal o inquérito costuma tramitar na delegacia da circunscrição em que houve a prisão, e a apresentação ao juiz ocorre perante o TJDFT, com plantão judiciário em fins de semana e feriados. O deslocamento até delegacias do DF nas primeiras horas é feito pessoalmente.',
    baseLegal:
      'Arts. 301 a 310 do Código de Processo Penal, art. 5º, LXI a LXVI, da Constituição Federal e Resolução nº 213/2015 do CNJ.',
    relacionadas: ['audiencia-de-custodia', 'liberdade-provisoria', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'Quanto tempo tenho para agir depois de uma prisão em flagrante?',
        resposta:
          'A audiência de custódia deve ocorrer em até 24 horas da prisão. Na prática, isso significa que a defesa tem menos de um dia para reunir documentos, entender os fatos e preparar o pedido de liberdade. Quanto antes o advogado for acionado, maior o espaço de atuação.',
      },
      {
        pergunta: 'A pessoa presa pode falar com o advogado antes da audiência?',
        resposta:
          'Sim. O advogado tem direito de comunicar-se com o cliente preso, pessoal e reservadamente, mesmo sem procuração e ainda que se trate de prisão em regime fechado — prerrogativa do art. 7º, III, do Estatuto da Advocacia.',
      },
      {
        pergunta: 'Pagar fiança resolve?',
        resposta:
          'A fiança é apenas uma das medidas cautelares possíveis e não cabe em todos os casos. Em muitas situações a liberdade é concedida sem fiança, com outras condições; em outras, nem a fiança é admitida. A análise depende do crime imputado e das circunstâncias pessoais.',
      },
    ],
  },

  {
    id: 'custodia',
    slug: 'audiencia-de-custodia',
    cluster: 'prisao',
    pai: 'prisao-em-flagrante',
    icone: 'relogio',
    titulo: 'Audiência de Custódia',
    h1: 'Advogado para Audiência de Custódia',
    seo: {
      titulo: 'Audiência de Custódia | Advogado Criminalista 24h',
      descricao:
        'Como funciona a audiência de custódia, o prazo de 24 horas, os direitos do preso e o que a defesa pode pedir. Atuação em todo o Brasil, com plantão.',
    },
    resumo:
      'A primeira vez que o preso vê um juiz — e a chance mais concreta de sair.',
    itens: [
      'Prazo de 24 horas',
      'Liberdade provisória',
      'Relaxamento de prisão',
      'Registro de maus-tratos',
    ],
    intro: [
      'A audiência de custódia é a apresentação do preso a um juiz em até 24 horas após a prisão em flagrante. Não se discute ali se a pessoa é culpada: discute-se se a prisão foi legal, se houve violência na abordagem e se ela precisa continuar presa enquanto o caso é apurado.',
      'É uma audiência curta, muitas vezes de poucos minutos, e é a única oportunidade em que o juiz vê o preso pessoalmente antes de decidir sobre a liberdade. Chegar nela sem defesa preparada é desperdiçar o momento mais favorável do procedimento inteiro.',
    ],
    quandoProcurar: [
      'A prisão ocorreu há poucas horas e a audiência ainda vai acontecer',
      'A audiência foi designada e não há advogado constituído',
      'Houve agressão, lesão ou tortura durante a abordagem ou na delegacia',
      'A prisão foi convertida em preventiva na audiência',
      'Passaram-se mais de 24 horas e a apresentação não aconteceu',
    ],
    comoAtuamos: [
      'Entrevista prévia e reservada com o custodiado antes do ato',
      'Reunião de documentos que demonstram residência fixa, trabalho e vínculos',
      'Arguição de nulidade quando a prisão ou a abordagem foram ilegais',
      'Requerimento de registro em ata de eventuais maus-tratos, com pedido de perícia',
      'Sustentação pela liberdade provisória e por medidas cautelares alternativas',
      'Habeas corpus imediato se a preventiva for decretada sem fundamentação concreta',
    ],
    brasilia:
      'No Distrito Federal as apresentações são feitas perante o juízo competente do TJDFT, inclusive em regime de plantão nos fins de semana e feriados. Como o DF não se divide em municípios, a circunscrição judiciária segue a região administrativa em que ocorreu a prisão.',
    baseLegal:
      'Art. 310 do Código de Processo Penal, Resolução nº 213/2015 do CNJ e Convenção Americana sobre Direitos Humanos, art. 7º, item 5.',
    relacionadas: ['prisao-em-flagrante', 'liberdade-provisoria', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'O que o juiz decide na audiência de custódia?',
        resposta:
          'Uma de três coisas: relaxar a prisão, se ela foi ilegal; conceder liberdade provisória, com ou sem medidas cautelares; ou converter o flagrante em prisão preventiva. O mérito da acusação não é julgado nesse momento.',
      },
      {
        pergunta: 'A família pode assistir?',
        resposta:
          'A audiência não é aberta como uma sessão pública comum, e a presença de familiares depende da estrutura e da decisão do juízo. O que a defesa costuma fazer é levar aos autos os documentos que a família reúne — comprovante de residência, carteira de trabalho, declarações — porque são eles que sustentam o pedido de liberdade.',
      },
      {
        pergunta: 'E se a audiência não acontecer em 24 horas?',
        resposta:
          'O descumprimento do prazo é fundamento para questionar a prisão. Os tribunais divergem sobre a consequência automática, mas a demora injustificada é argumento relevante em habeas corpus, sobretudo somada a outras irregularidades.',
      },
    ],
  },

  {
    id: 'liberdade',
    slug: 'liberdade-provisoria',
    cluster: 'prisao',
    pai: 'prisao-em-flagrante',
    icone: 'check',
    titulo: 'Liberdade Provisória',
    h1: 'Advogado para Liberdade Provisória',
    seo: {
      titulo: 'Advogado para Liberdade Provisória | Responder Solto',
      descricao:
        'Quem tem direito a responder ao processo em liberdade, quais medidas cautelares substituem a prisão e como a defesa constrói o pedido. Todo o Brasil.',
    },
    resumo:
      'A regra do processo penal é responder solto. A prisão antes da condenação é exceção.',
    itens: [
      'Medidas cautelares alternativas',
      'Fiança',
      'Revogação de preventiva',
      'Monitoramento eletrônico',
    ],
    intro: [
      'A Constituição presume a inocência, e o Código de Processo Penal trata a prisão antes do trânsito em julgado como medida excepcional. Na prática, porém, a preventiva é decretada com frequência, e cabe à defesa demonstrar que os requisitos legais não estão presentes ou que outra medida basta.',
      'A liberdade provisória raramente é concedida por insistência. Ela é concedida quando a defesa apresenta um quadro concreto: quem é a pessoa, onde mora, do que vive, que vínculos tem e por que não há risco em deixá-la responder solta.',
    ],
    quandoProcurar: [
      'A prisão em flagrante foi convertida em preventiva',
      'O processo se arrasta e a prisão já dura mais do que o razoável',
      'Surgiram fatos novos: emprego, residência fixa, filho, doença',
      'A preventiva foi decretada com fundamentação genérica',
      'Você quer antecipar o risco de prisão antes de uma audiência',
    ],
    comoAtuamos: [
      'Reunião da documentação pessoal que sustenta os vínculos com o distrito da culpa',
      'Demonstração da ausência dos requisitos do art. 312 do CPP',
      'Proposta fundamentada de medidas cautelares do art. 319 do CPP',
      'Pedido de revogação da preventiva diante de fato novo',
      'Arbitramento ou redução de fiança quando o valor é incompatível com a renda',
      'Habeas corpus ao tribunal quando o pedido é negado em primeiro grau',
    ],
    brasilia:
      'No Distrito Federal os pedidos tramitam nas varas criminais da circunscrição correspondente do TJDFT. O acompanhamento presencial reduz o intervalo entre a decisão e a expedição efetiva do alvará de soltura, que é onde costuma se perder tempo.',
    baseLegal:
      'Arts. 310, 312, 319 a 350 do Código de Processo Penal e art. 5º, LVII e LXVI, da Constituição Federal.',
    relacionadas: ['prisao-em-flagrante', 'audiencia-de-custodia', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'Quem tem direito a liberdade provisória?',
        resposta:
          'Não é uma lista fechada. O juiz concede quando não estão presentes os requisitos da prisão preventiva — garantia da ordem pública, da instrução ou da aplicação da lei penal. Primariedade, bons antecedentes, residência fixa e ocupação lícita pesam a favor, mas nenhum deles garante a soltura isoladamente.',
      },
      {
        pergunta: 'Que medidas podem substituir a prisão?',
        resposta:
          'O art. 319 do CPP prevê, entre outras, comparecimento periódico em juízo, proibição de acesso a determinados lugares, proibição de contato com pessoas certas, recolhimento domiciliar noturno, fiança e monitoração eletrônica. Elas podem ser combinadas.',
      },
      {
        pergunta: 'Negaram o pedido. Acabou?',
        resposta:
          'Não. A negativa pode ser atacada por habeas corpus dirigido ao tribunal, e o pedido pode ser renovado em primeiro grau sempre que surgir fato novo. Prisão preventiva não tem prazo fixo, mas também não pode se eternizar sem justificativa.',
      },
    ],
  },

  {
    id: 'habeas',
    slug: 'habeas-corpus',
    cluster: 'habeas-corpus',
    pilar: true,
    icone: 'recursos',
    titulo: 'Habeas Corpus',
    h1: 'Advogado para Habeas Corpus',
    seo: {
      titulo: 'Advogado para Habeas Corpus | Atuação no STJ e no STF',
      descricao:
        'Habeas corpus liberatório e preventivo, com pedido de liminar. Atuação nos tribunais superiores, sediados em Brasília, para clientes de todo o Brasil.',
    },
    resumo:
      'O instrumento mais rápido do sistema contra constrangimento ilegal à liberdade.',
    itens: [
      'HC liberatório',
      'HC preventivo',
      'Liminar',
      'Trancamento de ação penal',
      'Excesso de prazo',
    ],
    intro: [
      'O habeas corpus é a ação constitucional contra qualquer violência ou coação ilegal à liberdade de locomoção. Não tem custas, não depende de forma solene e pode ser impetrado a qualquer momento — inclusive por quem não é advogado, embora a atuação técnica mude completamente as chances de êxito.',
      'É o caminho para atacar prisão preventiva sem fundamentação concreta, excesso de prazo na instrução, denúncia genérica que não descreve a conduta individualizada e decisões que contrariam entendimento consolidado dos tribunais.',
    ],
    quandoProcurar: [
      'A prisão preventiva foi decretada ou mantida sem fundamentação concreta',
      'O processo se arrasta com o réu preso além do prazo razoável',
      'A denúncia é genérica e não descreve o que cada acusado fez',
      'Há risco concreto e iminente de prisão (caso de habeas corpus preventivo)',
      'O pedido foi negado em primeiro e segundo graus e é hora de subir ao STJ',
    ],
    comoAtuamos: [
      'Habeas corpus liberatório e preventivo, com pedido de liminar',
      'Trancamento de ação penal ou de inquérito por ausência de justa causa',
      'Impetração no tribunal de segundo grau, no STJ e no STF',
      'Agravo em recurso especial e reclamação constitucional',
      'Sustentação oral presencial nas sessões de julgamento',
      'Acompanhamento de gabinete até a inclusão em pauta',
    ],
    brasilia:
      'É aqui que a base em Brasília vira vantagem para cliente de qualquer estado: o STJ e o STF ficam na cidade. Quando o habeas corpus sobe aos tribunais superiores, protocolo, despacho com gabinete e sustentação oral presencial acontecem sem depender de correspondente nem de deslocamento aéreo a cada movimentação.',
    baseLegal:
      'Art. 5º, LXVIII, da Constituição Federal e arts. 647 a 667 do Código de Processo Penal.',
    relacionadas: ['prisao-em-flagrante', 'liberdade-provisoria', 'recursos-criminais'],
    faq: [
      {
        pergunta: 'Quanto tempo demora um habeas corpus?',
        resposta:
          'Quando há pedido de liminar, a análise costuma ocorrer em poucos dias — às vezes em horas, em situações de urgência. O julgamento do mérito pelo colegiado leva mais tempo, mas a liminar já pode assegurar a liberdade nesse intervalo.',
      },
      {
        pergunta: 'Quem pode impetrar habeas corpus?',
        resposta:
          'Qualquer pessoa, em favor próprio ou de outra, sem necessidade de advogado e sem custas. Na prática, a peça precisa demonstrar tecnicamente a ilegalidade e instruir o pedido com as decisões atacadas — é aí que a atuação profissional faz diferença.',
      },
      {
        pergunta: 'Qual a diferença entre habeas corpus preventivo e liberatório?',
        resposta:
          'O liberatório busca cessar uma restrição que já existe, como uma prisão em curso. O preventivo é usado quando há ameaça concreta e iminente à liberdade, e o que se pede é o salvo-conduto para impedir que a prisão aconteça.',
      },
    ],
  },

  /* ===================== CLUSTER: JÚRI ===================== */
  {
    id: 'juri',
    slug: 'tribunal-do-juri',
    cluster: 'juri',
    pilar: true,
    icone: 'juri',
    titulo: 'Tribunal do Júri',
    h1: 'Advogado de Tribunal do Júri',
    seo: {
      titulo: 'Advogado de Tribunal do Júri | Defesa em Homicídio',
      descricao:
        'Defesa em homicídio, feminicídio e tentativa de homicídio, do inquérito à sustentação em plenário. Atuação em todo o Brasil, com base em Brasília.',
    },
    resumo:
      'Defesa em crimes dolosos contra a vida, do inquérito à sustentação oral em plenário.',
    itens: ['Homicídio', 'Feminicídio', 'Tentativa de homicídio', 'Participação em suicídio'],
    intro: [
      'Os crimes dolosos contra a vida são julgados por sete jurados sorteados entre cidadãos comuns, e não por um juiz de carreira. Isso muda tudo: a defesa precisa ser tecnicamente impecável nos autos e, ao mesmo tempo, compreensível para quem nunca leu um processo.',
      'O procedimento é escalonado. Na primeira fase, o juiz decide se há indícios suficientes para levar o caso a júri — é ali que se buscam a impronúncia, a absolvição sumária ou a desclassificação para crime menos grave. Só depois vem o plenário. Perder a primeira fase por defesa malfeita é o erro mais caro que existe nessa área.',
    ],
    quandoProcurar: [
      'Você foi intimado a depor sobre uma morte violenta, ainda que como testemunha',
      'Houve indiciamento por homicídio, tentativa de homicídio ou feminicídio',
      'O Ministério Público ofereceu denúncia e o juiz mandou apresentar resposta',
      'Foi proferida decisão de pronúncia',
      'Já existe data marcada para a sessão de julgamento em plenário',
    ],
    comoAtuamos: [
      'Acompanhamento desde o inquérito, com pedido de diligências e acesso aos autos',
      'Resposta à acusação com preliminares, provas e rol de testemunhas',
      'Teses de impronúncia, absolvição sumária ou desclassificação na primeira fase',
      'Recurso em sentido estrito contra a decisão de pronúncia',
      'Preparação da prova oral e da estratégia de plenário, incluindo a quesitação',
      'Sustentação oral perante o Conselho de Sentença',
      'Apelação com base no art. 593, III, do Código de Processo Penal',
    ],
    brasilia:
      'O TJDFT mantém varas próprias do Tribunal do Júri, e as sessões ocorrem nos fóruns das circunscrições do Distrito Federal. A proximidade permite acompanhar sorteio de jurados, diligências e audiências sem intermediários.',
    baseLegal:
      'Arts. 121 a 128 do Código Penal, arts. 406 a 497 do Código de Processo Penal e art. 5º, XXXVIII, da Constituição Federal.',
    relacionadas: ['prisao-em-flagrante', 'recursos-criminais', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'É possível evitar que o caso vá a júri?',
        resposta:
          'Sim. Ao final da primeira fase, o juiz pode impronunciar o acusado (quando não há indícios suficientes de autoria), absolvê-lo sumariamente (por exemplo, em legítima defesa comprovada) ou desclassificar a conduta para um crime que não seja de competência do júri. Cada saída depende do que a prova dos autos permitir.',
      },
      {
        pergunta: 'Quanto tempo demora um processo no Tribunal do Júri?',
        resposta:
          'Não há prazo único. A primeira fase costuma levar meses; entre a pronúncia e o plenário, o intervalo varia conforme a pauta da vara e a complexidade da prova. Réus presos têm prioridade de tramitação.',
      },
      {
        pergunta: 'O réu precisa comparecer ao julgamento?',
        resposta:
          'Desde a Lei nº 11.689/2008, o julgamento pode ocorrer sem a presença do réu solto que tenha sido regularmente intimado. Ainda assim, a presença costuma ser estrategicamente relevante e é avaliada caso a caso com a defesa.',
      },
    ],
  },

  /* ===================== CLUSTER: DROGAS ===================== */
  {
    id: 'drogas',
    slug: 'lei-de-drogas',
    cluster: 'drogas',
    pilar: true,
    icone: 'drogas',
    titulo: 'Lei de Drogas',
    h1: 'Advogado e a Lei de Drogas (Lei nº 11.343/2006)',
    seo: {
      titulo: 'Lei de Drogas | Advogado Criminalista — Lei 11.343/2006',
      descricao:
        'Como a Lei nº 11.343/2006 separa usuário de traficante, o que é tráfico privilegiado e quando a busca é ilegal. Defesa criminal em todo o Brasil.',
    },
    resumo:
      'O procedimento inteiro da Lei nº 11.343/2006 — do porte para consumo à associação.',
    itens: [
      'Porte para consumo (art. 28)',
      'Tráfico (art. 33)',
      'Associação (art. 35)',
      'Busca pessoal e domiciliar',
    ],
    intro: [
      'A Lei nº 11.343/2006 organiza três situações muito diferentes sob o mesmo diploma: quem porta droga para consumo próprio, quem trafica e quem se associa para traficar. As consequências vão de medidas educativas, sem pena de prisão, a anos de reclusão em regime fechado.',
      'A lei não fixa quantidade que separe uma coisa da outra. Essa definição depende da análise da quantidade, da natureza da substância, do local, das circunstâncias da apreensão e das condições pessoais de quem foi abordado — e é exatamente aí que a defesa atua.',
    ],
    quandoProcurar: [
      'Houve apreensão de entorpecente em abordagem policial',
      'A acusação é de tráfico, mas a droga se destinava ao consumo próprio',
      'Policiais entraram em residência sem mandado judicial',
      'Foi imputada associação para o tráfico sem prova de vínculo estável',
      'A pena foi fixada sem o redutor do tráfico privilegiado',
    ],
    comoAtuamos: [
      'Discussão da licitude da busca pessoal e domiciliar',
      'Tese de desclassificação para porte destinado a consumo pessoal (art. 28)',
      'Aplicação da causa de diminuição do art. 33, § 4º (tráfico privilegiado)',
      'Impugnação da associação quando não há estabilidade do vínculo',
      'Afastamento da hediondez para fins de progressão de regime',
      'Pedido de liberdade provisória e de substituição da pena quando cabível',
    ],
    brasilia:
      'No Distrito Federal os inquéritos por drogas são conduzidos pela Polícia Civil do DF e distribuídos às varas criminais da circunscrição correspondente do TJDFT. Quando há indício de tráfico interestadual, a competência pode se deslocar para a Justiça Federal, também sediada na capital.',
    baseLegal:
      'Lei nº 11.343/2006, especialmente arts. 28, 33, 35 e 42, e art. 5º, XI, da Constituição Federal.',
    relacionadas: ['trafico-de-drogas', 'prisao-em-flagrante', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'Existe uma quantidade que define o tráfico?',
        resposta:
          'A lei não fixa quantidade. O art. 28, § 2º, manda considerar a natureza e a quantidade da substância, o local e as condições da ação, além das circunstâncias sociais e pessoais e da conduta e antecedentes do agente. A quantidade é apenas um dos elementos, e não o único.',
      },
      {
        pergunta: 'Porte para consumo dá cadeia?',
        resposta:
          'Não. O art. 28 prevê advertência, prestação de serviços à comunidade e medida educativa de comparecimento a programa ou curso — não há pena privativa de liberdade para essa conduta.',
      },
      {
        pergunta: 'A polícia pode entrar em casa sem mandado?',
        resposta:
          'Só em caso de flagrante, desastre, socorro ou com consentimento do morador. O Supremo Tribunal Federal exige que existam fundadas razões, demonstradas depois, que justifiquem a entrada. Sem isso, a prova pode ser declarada ilícita.',
      },
    ],
  },

  {
    id: 'trafico',
    slug: 'trafico-de-drogas',
    cluster: 'drogas',
    pai: 'lei-de-drogas',
    icone: 'drogas',
    titulo: 'Tráfico de Drogas',
    h1: 'Advogado de Tráfico de Drogas',
    seo: {
      titulo: 'Advogado de Tráfico de Drogas | Defesa Criminal',
      descricao:
        'Defesa em acusação de tráfico: desclassificação para uso, tráfico privilegiado, nulidade de busca e pedido de liberdade. Atendimento em todo o Brasil.',
    },
    resumo:
      'A acusação mais comum entre as prisões em flagrante — e a que mais depende de como a prova foi obtida.',
    itens: [
      'Desclassificação para uso',
      'Tráfico privilegiado',
      'Nulidade de busca',
      'Regime de cumprimento',
    ],
    intro: [
      'A acusação de tráfico carrega consequências severas: pena mínima alta, equiparação a crime hediondo e, em muitos casos, prisão preventiva desde o flagrante. Mas boa parte dessas prisões nasce de abordagens em via pública ou de entradas em domicílio, e é a legalidade desse primeiro ato que sustenta ou derruba todo o resto.',
      'Quando não há justa causa prévia e demonstrada para a busca, a prova obtida pode ser inválida — e, com ela, cai a acusação inteira. Quando a prova se sustenta, a discussão passa a ser sobre a natureza da conduta, o redutor do § 4º e o regime de cumprimento.',
    ],
    quandoProcurar: [
      'Houve prisão em flagrante por tráfico',
      'A abordagem começou sem motivo concreto e resultou em revista',
      'A entrada na residência foi feita sem mandado e sem flagrante prévio',
      'A denúncia atribui tráfico a quem é usuário',
      'A sentença negou o tráfico privilegiado a réu primário',
    ],
    comoAtuamos: [
      'Exame da fundada suspeita que autorizou a busca pessoal',
      'Impugnação da entrada em domicílio sem mandado',
      'Tese de desclassificação para o art. 28 quando a destinação é o consumo',
      'Aplicação do redutor do art. 33, § 4º, e seus reflexos no regime inicial',
      'Substituição da pena privativa de liberdade quando os requisitos estão presentes',
      'Pedido de liberdade provisória e recurso ao tribunal',
    ],
    brasilia:
      'No Distrito Federal, prisões por tráfico costumam começar em abordagem da Polícia Militar e ser formalizadas na delegacia da região administrativa. O acompanhamento presencial desde a delegacia permite documentar as circunstâncias da abordagem enquanto elas ainda podem ser apuradas.',
    baseLegal:
      'Arts. 33 e 35 da Lei nº 11.343/2006, art. 5º, XI e LVI, da Constituição Federal e art. 244 do Código de Processo Penal.',
    relacionadas: ['lei-de-drogas', 'prisao-em-flagrante', 'execucao-penal'],
    faq: [
      {
        pergunta: 'O que é tráfico privilegiado?',
        resposta:
          'É a causa de diminuição de pena do art. 33, § 4º, da Lei de Drogas, aplicável a quem é primário, tem bons antecedentes, não se dedica a atividades criminosas nem integra organização criminosa. A redução vai de um sexto a dois terços e pode mudar o regime inicial de cumprimento.',
      },
      {
        pergunta: 'Tráfico é sempre inafiançável e hediondo?',
        resposta:
          'O tráfico é equiparado a hediondo, mas o Supremo Tribunal Federal já afastou essa equiparação para a figura do tráfico privilegiado. A consequência prática aparece na progressão de regime e no livramento condicional, com percentuais menores.',
      },
      {
        pergunta: 'Só a palavra dos policiais condena?',
        resposta:
          'O depoimento policial é prova válida e é frequentemente admitido pelos tribunais. Isso não impede que a defesa demonstre contradições entre as versões, incompatibilidade com a prova material ou irregularidade na abordagem — que é onde a discussão realmente se decide.',
      },
    ],
  },

  /* ===================== SERVIÇOS ===================== */
  {
    id: 'patrimonio',
    slug: 'crimes-contra-o-patrimonio',
    cluster: 'patrimonio',
    icone: 'patrimonio',
    titulo: 'Crimes Contra o Patrimônio',
    h1: 'Advogado de Crimes Contra o Patrimônio',
    seo: {
      titulo: 'Advogado de Furto, Roubo e Estelionato | Defesa Criminal',
      descricao:
        'Defesa em furto, roubo, estelionato, receptação e apropriação indébita. Análise do reconhecimento, da autoria e das qualificadoras. Todo o Brasil.',
    },
    resumo:
      'Defesa técnica em acusações patrimoniais, com análise minuciosa da prova e da autoria.',
    itens: ['Furto', 'Roubo', 'Estelionato', 'Receptação', 'Apropriação indébita'],
    intro: [
      'Acusações patrimoniais são as mais comuns do sistema criminal e, justamente por isso, as que mais sofrem com investigações padronizadas. Reconhecimentos fotográficos feitos de qualquer jeito, prisões baseadas apenas na palavra de um policial e qualificadoras somadas sem prova são problemas que aparecem com frequência.',
      'A diferença entre furto e roubo, entre consumação e tentativa, ou entre estelionato e mero inadimplemento civil pode representar anos de pena — ou a própria atipicidade da conduta.',
    ],
    quandoProcurar: [
      'Você foi indiciado ou denunciado por furto, roubo, estelionato ou receptação',
      'Houve reconhecimento fotográfico ou pessoal que você considera equivocado',
      'A acusação atribui qualificadoras sem prova clara',
      'A discussão é contratual e foi transformada em acusação de estelionato',
      'Você comprou um bem sem saber da origem ilícita e foi acusado de receptação',
    ],
    comoAtuamos: [
      'Impugnação de reconhecimentos feitos fora do rito do art. 226 do CPP',
      'Questionamento de qualificadoras e causas de aumento não comprovadas',
      'Teses de desclassificação, tentativa e furto privilegiado',
      'Demonstração da ausência de dolo na receptação',
      'Discussão do princípio da insignificância nos casos cabíveis',
      'Pedido de restituição de bens apreendidos',
      'Acordo de não persecução penal quando presentes os requisitos legais',
    ],
    brasilia:
      'No Distrito Federal esses processos tramitam nas varas criminais das circunscrições do TJDFT, com o inquérito conduzido pela Polícia Civil do DF. Estar na praça permite acompanhar audiências de instrução e diligências de reconhecimento pessoalmente.',
    baseLegal: 'Arts. 155 a 180 do Código Penal e art. 28-A do Código de Processo Penal.',
    relacionadas: ['prisao-em-flagrante', 'crimes-digitais', 'execucao-penal'],
    faq: [
      {
        pergunta: 'Devolver o bem furtado extingue o crime?',
        resposta:
          'Não extingue, mas pode ter peso relevante. No furto, a reparação do dano antes do recebimento da denúncia pode configurar arrependimento posterior, com redução de pena (art. 16 do Código Penal), além de influenciar a dosimetria e a possibilidade de acordo.',
      },
      {
        pergunta: 'O que é o princípio da insignificância?',
        resposta:
          'É a tese de que condutas de lesão mínima ao bem jurídico não devem ser punidas penalmente. Os tribunais analisam a mínima ofensividade, a ausência de periculosidade social, o reduzido grau de reprovabilidade e a inexpressividade da lesão. Não se aplica ao roubo, por envolver violência ou grave ameaça.',
      },
      {
        pergunta: 'Fui reconhecido por foto. Isso basta para me condenar?',
        resposta:
          'O Superior Tribunal de Justiça vem decidindo que o reconhecimento realizado sem observar o procedimento do art. 226 do Código de Processo Penal é prova inválida e, isoladamente, não sustenta condenação. É um dos pontos que a defesa examina primeiro.',
      },
    ],
  },

  {
    id: 'domestica',
    slug: 'violencia-domestica',
    cluster: 'domestica',
    icone: 'domestica',
    titulo: 'Violência Doméstica',
    h1: 'Advogado de Violência Doméstica e Familiar',
    seo: {
      titulo: 'Advogado de Violência Doméstica | Lei Maria da Penha',
      descricao:
        'Atuação em procedimentos da Lei Maria da Penha, na defesa do acusado ou na assistência à vítima. Medidas protetivas e descumprimento. Todo o Brasil.',
    },
    resumo:
      'Atuação em procedimentos da Lei Maria da Penha, na defesa do acusado ou na assistência à vítima.',
    itens: [
      'Medidas protetivas de urgência',
      'Descumprimento de medida protetiva',
      'Lesão corporal e ameaça',
    ],
    intro: [
      'A Lei nº 11.340/2006 criou um rito próprio, mais rápido e mais rigoroso, para os casos de violência doméstica e familiar contra a mulher. Medidas protetivas podem ser deferidas em 48 horas, muitas vezes antes de o acusado ser ouvido, e o seu descumprimento é crime autônomo com pena de detenção.',
      'A atuação aqui exige equilíbrio. Do lado da defesa, é preciso enfrentar a acusação sem desqualificar a vítima. Do lado da assistência, é preciso garantir que a proteção seja efetiva e que a palavra da ofendida tenha o peso processual que a lei lhe dá.',
    ],
    quandoProcurar: [
      'Você foi notificado de medidas protetivas de urgência',
      'Há acusação de ameaça, lesão corporal ou injúria em contexto familiar',
      'Você é acusado de descumprir uma medida protetiva já deferida',
      'Você sofreu violência e precisa requerer proteção com urgência',
      'O processo envolve disputa de guarda ou divórcio em paralelo',
    ],
    comoAtuamos: [
      'Pedido de revisão, revogação ou adequação das medidas protetivas',
      'Defesa em ação penal por ameaça, lesão corporal e crimes correlatos',
      'Demonstração da ausência dos requisitos do art. 5º da Lei Maria da Penha',
      'Produção de prova documental e testemunhal sobre o contexto dos fatos',
      'Assistência à vítima, com protetivas e habilitação como assistente de acusação',
      'Articulação com a área de família quando há guarda ou alimentos envolvidos',
    ],
    brasilia:
      'No Distrito Federal as ocorrências podem ser registradas nas Delegacias Especiais de Atendimento à Mulher, e os procedimentos tramitam nos juizados especializados de violência doméstica e familiar do TJDFT, que também apreciam os pedidos de medida protetiva.',
    baseLegal:
      'Lei nº 11.340/2006, especialmente arts. 5º, 22 e 24-A, e arts. 129 e 147 do Código Penal.',
    relacionadas: ['prisao-em-flagrante', 'crimes-contra-a-honra', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'A vítima pode retirar a queixa?',
        resposta:
          'Depende do crime. Na ameaça, que é de ação penal pública condicionada, a representação pode ser retratada perante o juiz, em audiência, até o recebimento da denúncia. Já na lesão corporal em contexto doméstico a ação é pública incondicionada — o processo segue mesmo que a vítima não queira, conforme decidido pelo Supremo Tribunal Federal.',
      },
      {
        pergunta: 'Descumprir medida protetiva dá cadeia?',
        resposta:
          'O art. 24-A da Lei Maria da Penha tipifica o descumprimento como crime autônomo, com pena de detenção de três meses a dois anos, além de autorizar a prisão preventiva. Mesmo contato aparentemente inofensivo, como mensagem, pode configurar a conduta.',
      },
      {
        pergunta: 'A Lei Maria da Penha se aplica só a casais?',
        resposta:
          'Não. Ela alcança a violência praticada no âmbito da unidade doméstica, da família ou em qualquer relação íntima de afeto, independentemente de coabitação — o que inclui, por exemplo, relações entre pais e filhas, irmãos e ex-companheiros.',
      },
    ],
  },

  {
    id: 'transito',
    slug: 'crimes-de-transito',
    cluster: 'transito',
    icone: 'transito',
    titulo: 'Crimes de Trânsito',
    h1: 'Advogado de Crimes de Trânsito',
    seo: {
      titulo: 'Advogado de Crimes de Trânsito | Embriaguez ao Volante',
      descricao:
        'Defesa em embriaguez ao volante, homicídio e lesão culposa na direção e fuga do local. Reflexos penais e na suspensão do direito de dirigir.',
    },
    resumo:
      'Defesa nas infrações penais do Código de Trânsito e seus reflexos administrativos.',
    itens: [
      'Embriaguez ao volante',
      'Homicídio culposo na direção',
      'Lesão corporal culposa',
      'Fuga do local do acidente',
    ],
    intro: [
      'Crimes de trânsito atingem pessoas que nunca imaginaram responder a um processo criminal. E têm uma particularidade: além da pena, quase sempre vem a suspensão do direito de dirigir, que para muita gente é mais grave do que a sanção penal em si.',
      'A prova costuma ser técnica — etilômetro, exame clínico, laudo de local, perícia de velocidade — e a defesa começa exatamente pela verificação de como esses elementos foram produzidos.',
    ],
    quandoProcurar: [
      'Você foi autuado por dirigir sob influência de álcool',
      'Houve acidente com vítima ferida ou morta',
      'Você deixou o local do acidente e foi acusado de fuga',
      'A acusação sustenta dolo eventual em vez de culpa',
      'Foi aplicada suspensão do direito de dirigir',
    ],
    comoAtuamos: [
      'Verificação da validade do etilômetro e da cadeia de custódia da prova',
      'Impugnação do exame clínico feito sem os requisitos regulamentares',
      'Discussão entre culpa consciente e dolo eventual',
      'Demonstração da ausência de nexo causal entre a conduta e o resultado',
      'Composição civil e transação penal nas infrações de menor potencial ofensivo',
      'Pedidos relativos à suspensão e à reabilitação do direito de dirigir',
    ],
    brasilia:
      'No Distrito Federal as ocorrências de trânsito com vítima são registradas pela Polícia Civil do DF e os processos tramitam no TJDFT, com os casos de menor potencial ofensivo indo aos juizados especiais criminais. A esfera administrativa corre em paralelo no Detran-DF.',
    baseLegal: 'Arts. 291 a 312-B da Lei nº 9.503/1997 (Código de Trânsito Brasileiro).',
    relacionadas: ['prisao-em-flagrante', 'crimes-contra-o-patrimonio', 'recursos-criminais'],
    faq: [
      {
        pergunta: 'Sou obrigado a soprar o bafômetro?',
        resposta:
          'Ninguém é obrigado a produzir prova contra si mesmo, e a recusa não configura crime. Ela configura, porém, infração administrativa gravíssima, com multa, suspensão do direito de dirigir e retenção do veículo. A embriaguez também pode ser comprovada por outros meios, como exame clínico, vídeo e testemunhas.',
      },
      {
        pergunta: 'Acidente com vítima sempre vira processo criminal?',
        resposta:
          'Nem sempre. Na lesão corporal culposa de trânsito é possível composição civil dos danos e transação penal, que evitam o processo. A situação muda quando há agravantes como embriaguez, racha ou omissão de socorro.',
      },
      {
        pergunta: 'Posso perder a carteira mesmo sem ser condenado?',
        resposta:
          'Sim. A suspensão administrativa do direito de dirigir tramita em processo próprio, no órgão de trânsito, e é independente da esfera penal. Por isso as duas frentes precisam ser acompanhadas em paralelo.',
      },
    ],
  },

  {
    id: 'digitais',
    slug: 'crimes-digitais',
    cluster: 'digitais',
    icone: 'digitais',
    titulo: 'Crimes Digitais',
    h1: 'Advogado de Crimes Digitais',
    seo: {
      titulo: 'Advogado de Crimes Digitais | Golpe e Fraude Online',
      descricao:
        'Estelionato digital, invasão de dispositivo, divulgação de imagens íntimas e prova eletrônica. Defesa e representação em todo o Brasil.',
    },
    resumo:
      'Casos que envolvem meio eletrônico, prova digital e responsabilização por publicações.',
    itens: [
      'Estelionato digital',
      'Invasão de dispositivo informático',
      'Divulgação não consentida de imagens',
      'Fraude bancária',
    ],
    intro: [
      'A prova digital é frágil e volátil: prints se perdem, contas são apagadas, registros de conexão têm prazo legal de guarda. Quem precisa comprovar uma fraude on-line tem que agir rápido e do jeito certo, sob pena de chegar ao processo sem prova nenhuma.',
      'Do lado da defesa, a discussão costuma girar em torno da autoria: um IP, um número de telefone ou uma conta bancária não identificam por si sós quem estava atrás do teclado.',
    ],
    quandoProcurar: [
      'Você foi vítima de golpe bancário ou de fraude em compra on-line',
      'Alguém acessou seu celular, e-mail ou perfil sem autorização',
      'Imagens íntimas suas foram divulgadas sem consentimento',
      'Sua conta foi usada por terceiros e você virou investigado',
      'Há acusação baseada apenas em registro de IP ou de dispositivo',
    ],
    comoAtuamos: [
      'Orientação sobre preservação de prova e ata notarial antes que o conteúdo desapareça',
      'Pedido judicial de quebra de registro de conexão e identificação de autoria',
      'Representação em estelionato praticado por meio eletrônico (art. 171, § 2º-A)',
      'Defesa quando a imputação se apoia apenas em vínculo indireto com o dispositivo',
      'Atuação em invasão de dispositivo informático (art. 154-A)',
      'Pedidos de remoção de conteúdo em articulação com a esfera cível',
    ],
    brasilia:
      'Quando a fraude envolve mais de um estado ou atinge o sistema financeiro, a competência tende a ser da Justiça Federal — cuja seção judiciária no DF fica em Brasília, assim como a sede da Polícia Federal, o que encurta o caminho para acompanhar inquéritos dessa natureza.',
    baseLegal:
      'Arts. 154-A, 171, § 2º-A, e 218-C do Código Penal, Lei nº 12.965/2014 (Marco Civil da Internet) e Lei nº 14.155/2021.',
    relacionadas: ['crimes-contra-a-honra', 'crimes-economicos', 'crimes-contra-o-patrimonio'],
    faq: [
      {
        pergunta: 'Print de conversa serve como prova?',
        resposta:
          'Serve, mas é prova frágil e facilmente impugnada, porque pode ser editada. O ideal é registrar o conteúdo em ata notarial em cartório e, em paralelo, requerer judicialmente os registros diretamente à plataforma.',
      },
      {
        pergunta: 'Um IP identifica o autor do crime?',
        resposta:
          'Identifica a conexão, não a pessoa. Redes compartilhadas, aparelhos usados por várias pessoas e contas invadidas são hipóteses comuns. A defesa examina se há elemento que ligue o investigado ao ato, além do registro técnico.',
      },
      {
        pergunta: 'Divulgar imagem íntima de outra pessoa é crime?',
        resposta:
          'Sim. O art. 218-C do Código Penal pune quem divulga, por qualquer meio, cena de sexo, nudez ou pornografia sem o consentimento da vítima, com pena aumentada quando praticado por quem manteve relação íntima com ela.',
      },
    ],
  },

  {
    id: 'honra',
    slug: 'crimes-contra-a-honra',
    cluster: 'digitais',
    icone: 'digitais',
    titulo: 'Crimes Contra a Honra',
    h1: 'Advogado de Crimes Contra a Honra',
    seo: {
      titulo: 'Advogado de Calúnia, Injúria e Difamação | Queixa-Crime',
      descricao:
        'Ofensa em rede social, queixa-crime e defesa por publicação. Prazo de seis meses para agir. Atuação em todo o Brasil.',
    },
    resumo:
      'Calúnia, injúria e difamação — inclusive quando a ofensa acontece em rede social.',
    itens: ['Calúnia', 'Injúria', 'Difamação', 'Injúria racial', 'Queixa-crime'],
    intro: [
      'Calúnia é imputar falsamente um crime; difamação é atribuir fato ofensivo à reputação; injúria é ofender a dignidade ou o decoro. Parecem próximos, mas têm penas, requisitos e estratégias de defesa diferentes, e confundi-los custa o caso.',
      'A maioria desses crimes é de ação penal privada: o ofendido precisa apresentar queixa-crime dentro de seis meses contados do dia em que soube quem foi o autor. Perdido esse prazo, o direito se extingue — e é assim que muita ofensa grave acaba sem resposta.',
    ],
    quandoProcurar: [
      'Você foi ofendido publicamente em rede social ou grupo de mensagens',
      'Alguém atribuiu a você um crime que você não cometeu',
      'Você responde a queixa-crime por algo que publicou',
      'A ofensa envolveu raça, cor, etnia, religião ou origem',
      'A publicação segue no ar e você quer removê-la',
    ],
    comoAtuamos: [
      'Preservação da prova por ata notarial antes da exclusão do conteúdo',
      'Queixa-crime dentro do prazo decadencial de seis meses',
      'Defesa com base na liberdade de expressão e na ausência de dolo específico',
      'Discussão das excludentes do art. 142 do Código Penal',
      'Distinção entre injúria racial e os crimes da Lei nº 7.716/1989',
      'Retratação e composição, quando são a melhor saída para o cliente',
    ],
    brasilia:
      'No Distrito Federal, as queixas-crime por ofensa à honra costumam tramitar nos juizados especiais criminais do TJDFT, por serem infrações de menor potencial ofensivo, com audiência preliminar de conciliação antes da instrução.',
    baseLegal:
      'Arts. 138 a 145 do Código Penal, art. 2º-A da Lei nº 7.716/1989 e arts. 519 a 523 do Código de Processo Penal.',
    relacionadas: ['crimes-digitais', 'violencia-domestica', 'recursos-criminais'],
    faq: [
      {
        pergunta: 'Qual o prazo para processar por ofensa?',
        resposta:
          'Nos crimes contra a honra de ação penal privada, o prazo decadencial é de seis meses contados do dia em que se soube quem é o autor do fato. Passado esse prazo, o direito de queixa se perde — por isso a demora costuma ser fatal nesses casos.',
      },
      {
        pergunta: 'Toda crítica é crime?',
        resposta:
          'Não. O art. 142 do Código Penal afasta a punição em hipóteses como a opinião desfavorável da crítica literária, artística ou científica e a ofensa irrogada em juízo na discussão da causa. A fronteira entre crítica dura e ofensa à honra é justamente o centro da discussão nesses processos.',
      },
      {
        pergunta: 'Qual a diferença entre injúria racial e racismo?',
        resposta:
          'A injúria racial ofende a dignidade de pessoa determinada usando elementos de raça, cor, etnia, religião ou origem. Os crimes da Lei nº 7.716/1989 atingem a coletividade, com condutas de segregação e impedimento de acesso. A Lei nº 14.532/2023 equiparou a injúria racial ao racismo para fins de pena.',
      },
    ],
  },

  {
    id: 'economicos',
    slug: 'crimes-economicos',
    cluster: 'economicos',
    icone: 'economicos',
    titulo: 'Crimes Econômicos',
    h1: 'Advogado de Crimes Econômicos e Empresariais',
    seo: {
      titulo: 'Advogado de Crimes Econômicos e Tributários | Defesa',
      descricao:
        'Defesa de pessoas físicas e empresas em crimes tributários, lavagem de dinheiro, licitações e crimes contra o sistema financeiro. Todo o Brasil.',
    },
    resumo:
      'Assessoria a pessoas físicas e empresas em investigações complexas e de repercussão financeira.',
    itens: [
      'Crimes tributários',
      'Lavagem de dinheiro',
      'Crimes contra o sistema financeiro',
      'Licitações e contratos',
    ],
    intro: [
      'Investigações econômicas são longas, documentais e costumam começar muito antes de o investigado saber que existem. Quando chegam a busca e apreensão ou quebra de sigilo, boa parte da prova já está formada.',
      'Essas apurações raramente ficam restritas à esfera criminal: correm em paralelo com o processo administrativo fiscal, a ação de improbidade e a discussão tributária, e as decisões de uma repercutem nas outras.',
    ],
    quandoProcurar: [
      'A empresa foi alvo de busca e apreensão ou de quebra de sigilo',
      'Você foi intimado a depor em inquérito da Polícia Federal',
      'Há representação fiscal para fins penais após auto de infração',
      'Existe investigação sobre contratos públicos ou licitações',
      'Foi decretada indisponibilidade ou sequestro de bens',
    ],
    comoAtuamos: [
      'Defesa desde o inquérito, com acesso aos autos e pedido de diligências',
      'Discussão da tipicidade e do dolo em crimes tributários',
      'Tese da Súmula Vinculante 24 sobre a necessidade de lançamento definitivo',
      'Impugnação de medidas cautelares patrimoniais desproporcionais',
      'Atuação conjunta com as áreas tributária e administrativa',
      'Negociação de acordos quando o quadro probatório e o interesse do cliente recomendam',
    ],
    brasilia:
      'Brasília concentra os órgãos federais de controle, a sede da Polícia Federal e a Seção Judiciária do DF, o que torna comum a competência federal nessas investigações e permite acompanhá-las de perto, inclusive quando o cliente e a empresa ficam em outro estado.',
    baseLegal:
      'Lei nº 8.137/1990, Lei nº 9.613/1998, Lei nº 7.492/1986, Lei nº 14.133/2021 e Súmula Vinculante 24 do STF.',
    relacionadas: ['crimes-digitais', 'recursos-criminais', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'Pagar o tributo extingue a punibilidade?',
        resposta:
          'Nos crimes contra a ordem tributária, o pagamento integral do débito extingue a punibilidade, e pode ser feito a qualquer tempo, inclusive após a condenação. O parcelamento, por sua vez, suspende a pretensão punitiva enquanto estiver sendo cumprido.',
      },
      {
        pergunta: 'Sou sócio, mas não administro. Posso responder?',
        resposta:
          'A responsabilidade penal é pessoal e exige demonstração concreta de participação. Denúncias genéricas, que imputam o crime a todos os sócios apenas pela posição no contrato social, são combatidas pela defesa e frequentemente trancadas por habeas corpus.',
      },
      {
        pergunta: 'O que é a Súmula Vinculante 24?',
        resposta:
          'Ela estabelece que não se tipifica crime material contra a ordem tributária antes do lançamento definitivo do tributo. Na prática, enquanto o processo administrativo fiscal não terminar, não há justa causa para a ação penal nesses casos.',
      },
    ],
  },

  {
    id: 'execucao',
    slug: 'execucao-penal',
    cluster: 'execucao',
    icone: 'execucao',
    titulo: 'Execução Penal',
    h1: 'Advogado de Execução Penal',
    seo: {
      titulo: 'Advogado de Execução Penal | Progressão de Regime',
      descricao:
        'Progressão de regime, livramento condicional, remição e defesa em falta disciplinar. Acompanhamento da pena em todo o Brasil.',
    },
    resumo:
      'Acompanhamento do cumprimento da pena e defesa dos direitos do apenado.',
    itens: [
      'Progressão de regime',
      'Livramento condicional',
      'Remição pelo trabalho e estudo',
      'Defesa em falta disciplinar',
    ],
    intro: [
      'A condenação não encerra o trabalho da defesa — em muitos casos, é onde ele passa a fazer mais diferença no dia a dia. Benefícios como progressão de regime, saída temporária e livramento condicional dependem de requerimento e de cálculo correto da pena.',
      'Sem acompanhamento, é comum que o apenado permaneça em regime mais gravoso por meses depois de já ter direito à progressão, apenas porque ninguém pediu.',
    ],
    quandoProcurar: [
      'A pena transitou em julgado e a execução foi instaurada',
      'O tempo para progressão de regime já foi cumprido',
      'Houve trabalho ou estudo que ainda não foi convertido em remição',
      'Foi instaurado procedimento por falta disciplinar grave',
      'O atestado de pena apresenta cálculo que parece equivocado',
    ],
    comoAtuamos: [
      'Conferência do cálculo de pena e do atestado emitido pela vara',
      'Pedido de progressão de regime nos percentuais do art. 112 da LEP',
      'Requerimento de livramento condicional e de saídas temporárias',
      'Remição pelo trabalho, pelo estudo e pela leitura',
      'Defesa em procedimento disciplinar, que pode interromper prazos de benefício',
      'Pedido de unificação de penas e de indulto quando cabível',
    ],
    brasilia:
      'No Distrito Federal a execução das penas privativas de liberdade tramita perante a Vara de Execuções Penais do TJDFT, o que concentra num único juízo os pedidos de progressão, remição e livramento de quem cumpre pena na capital.',
    baseLegal:
      'Lei nº 7.210/1984 (Lei de Execução Penal), especialmente arts. 112, 118 e 126, e art. 83 do Código Penal.',
    relacionadas: ['trafico-de-drogas', 'recursos-criminais', 'habeas-corpus'],
    faq: [
      {
        pergunta: 'Quando surge o direito à progressão de regime?',
        resposta:
          'O art. 112 da Lei de Execução Penal fixa percentuais que variam conforme o crime ser ou não hediondo, a reincidência e o resultado morte — indo de 16% a 70% da pena. Além do requisito temporal, exige-se boa conduta carcerária atestada pelo diretor do estabelecimento.',
      },
      {
        pergunta: 'Como funciona a remição?',
        resposta:
          'A cada três dias de trabalho, reduz-se um dia de pena; a cada doze horas de estudo divididas em pelo menos três dias, também. A leitura de obras literárias pode gerar remição adicional, conforme regulamentação. Tudo precisa ser comprovado e requerido.',
      },
      {
        pergunta: 'Falta grave atrasa a progressão?',
        resposta:
          'Sim. O reconhecimento de falta grave interrompe a contagem do prazo para progressão de regime, que recomeça a partir da data da infração. Por isso a defesa no procedimento disciplinar é tão importante quanto no processo de conhecimento.',
      },
    ],
  },

  {
    id: 'recursos',
    slug: 'recursos-criminais',
    cluster: 'habeas-corpus',
    pai: 'habeas-corpus',
    icone: 'recursos',
    titulo: 'Recursos Criminais',
    h1: 'Advogado para Recursos Criminais',
    seo: {
      titulo: 'Advogado para Recursos Criminais | Apelação, STJ e STF',
      descricao:
        'Apelação criminal, recurso em sentido estrito, recurso especial ao STJ, extraordinário ao STF e revisão criminal. Sustentação oral presencial.',
    },
    resumo:
      'Segunda instância e tribunais superiores, para quem já tem decisão desfavorável.',
    itens: [
      'Apelação criminal',
      'Recurso em sentido estrito',
      'Recurso especial e extraordinário',
      'Revisão criminal',
    ],
    intro: [
      'Uma sentença condenatória não é o fim do processo. A apelação devolve ao tribunal a análise da prova e da dosimetria; o recurso especial discute a interpretação da lei federal no STJ; o extraordinário leva a matéria constitucional ao STF. Cada um tem requisitos próprios, e errar a via custa o direito.',
      'Depois do trânsito em julgado, ainda resta a revisão criminal, que não tem prazo e pode ser proposta mesmo após o cumprimento integral da pena.',
    ],
    quandoProcurar: [
      'Houve sentença condenatória e o prazo de recurso está correndo',
      'A pena foi fixada acima do que a dosimetria autorizava',
      'O acórdão contrariou lei federal ou entendimento consolidado do STJ',
      'Há questão constitucional com repercussão geral envolvida',
      'A condenação transitou em julgado, mas surgiu prova nova',
    ],
    comoAtuamos: [
      'Apelação criminal e recurso em sentido estrito',
      'Revisão integral da dosimetria e das circunstâncias judiciais',
      'Recurso especial ao STJ e recurso extraordinário ao STF',
      'Agravo em recurso especial e reclamação constitucional',
      'Revisão criminal após o trânsito em julgado',
      'Sustentação oral presencial nas sessões de julgamento',
    ],
    brasilia:
      'STJ e STF ficam em Brasília. Para o cliente que mora em qualquer outro estado, isso significa que a fase recursal mais decisiva é acompanhada presencialmente — protocolo, memoriais em gabinete e sustentação oral — sem depender de advogado correspondente.',
    baseLegal:
      'Arts. 574 a 667 do Código de Processo Penal, art. 105, III, e art. 102, III, da Constituição Federal.',
    relacionadas: ['habeas-corpus', 'tribunal-do-juri', 'execucao-penal'],
    faq: [
      {
        pergunta: 'Posso trocar de advogado para recorrer?',
        resposta:
          'Sim, a qualquer momento. A escolha do defensor é direito do acusado, e a substituição se faz por nova procuração nos autos. É bastante comum a contratação de advogado específico para a fase recursal.',
      },
      {
        pergunta: 'Recorrer pode piorar a pena?',
        resposta:
          'Se apenas a defesa recorre, não. Vigora a proibição da reformatio in pejus: o tribunal não pode agravar a situação do réu em recurso exclusivo da defesa. O risco só existe se a acusação também tiver recorrido.',
      },
      {
        pergunta: 'O que é revisão criminal?',
        resposta:
          'É a ação que permite rever condenação já transitada em julgado, nas hipóteses do art. 621 do Código de Processo Penal: sentença contrária ao texto da lei ou à evidência dos autos, prova falsa ou descoberta de prova nova de inocência. Não tem prazo e pode ser proposta mesmo após o cumprimento da pena.',
      },
    ],
  },
];

export default servicos;

/** Busca um serviço pelo slug da URL. */
export function servicoPorSlug(slug) {
  return servicos.find((servico) => servico.slug === slug);
}

/** Os serviços indicados como relacionados, na ordem definida. */
export function relacionadosDe(servico) {
  return (servico.relacionadas || [])
    .map((slug) => servicoPorSlug(slug))
    .filter(Boolean);
}

/** Serviços do mesmo cluster, exceto o próprio. */
export function irmaosDe(servico) {
  return servicos.filter(
    (item) => item.cluster === servico.cluster && item.id !== servico.id
  );
}
